module.exports = __webpack_public_path__ + "static/media/M1-6-Jawari-Felasu-cod105.52a96e81.png";